/**
 * A staff account (Admin, Moderator, RegionalModerator) that signed in without two-factor gets an
 * ordinary-user session; the server flags it with `staffMfaRequired`. The fix is to turn on
 * two-step sign-in, then sign out and back in with the code.
 */
export const STAFF_MFA_SETUP_PATH = '/settings/security'

export const STAFF_MFA_NOTICE =
  'Your staff tools are off because you signed in without two-step sign-in. Turn it on, then sign out and sign back in with your code.'

export function shouldShowStaffMfaNotice(user: { staffMfaRequired?: boolean } | null | undefined): boolean {
  return user?.staffMfaRequired === true
}
